import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-text-input',
    templateUrl: './generic-text-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-text-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericTextInputComponent,
        },
    ],
})
export class GenericTextInputComponent extends BaseGenericInputComponent<string> implements OnDestroy {

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }

}
